import React from 'react';

/** Outline padlock — closed body with rounded shackle (Figma node 2563:18098). */
export const Lock: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3333 14H4.66667C3.93 14 3.33333 13.4033 3.33333 12.6667V8C3.33333 7.26333 3.93 6.66667 4.66667 6.66667H11.3333C12.07 6.66667 12.6667 7.26333 12.6667 8V12.6667C12.6667 13.4033 12.07 14 11.3333 14Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33333 6.66667V4.66667C5.33333 3.194 6.52733 2 8 2C9.47267 2 10.6667 3.194 10.6667 4.66667V6.66667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
